(() => {
  const configElement = document.getElementById('mxpro-native-filter-labels');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const normalize = value => value.normalize('NFC').replace(/\s+/g, ' ').trim().toLowerCase();
  const escapePattern = value => value.replace(/[.*+?^\${}()|[\]\\]/g, '\\$&');
  const colourPattern = new RegExp('(?<![\\p{L}\\p{N}])(?:' + Object.keys(config.colors).sort((a, b) => b.length - a.length).map(escapePattern).join('|') + ')(?![\\p{L}\\p{N}])', 'giu');
  function translated(name, original) {
    if (name === 'filter.p.m.custom.kleur') {
      return original.replace(colourPattern, value => config.colors[normalize(value)] || value);
    }
    return config.fields[name]?.[normalize(original)] || original;
  }
  let queued = false;
  function update() {
    queued = false;
    document.querySelectorAll('#MainContent [data-mxpro-filter-source]').forEach(element => {
      const original = element.dataset.mxproFilterSource;
      const label = translated(element.dataset.mxproFilterName, original);
      if (element.textContent !== label) element.textContent = label;
    });
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  const observed = new WeakSet();
  function bind() {
    const main = document.getElementById('MainContent');
    if (main && !observed.has(main)) {
      observed.add(main);
      new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
      schedule();
    }
  }
  new MutationObserver(bind).observe(document.body, { childList: true, subtree: true });
  bind();
})();

